export default "__VITE_ASSET__Fn1lXgee__"